<div class="accordion" [ngClass]="{'border-collapsed': isCollapsed, 'border-expanded': !isCollapsed}">
  <div class="accordion__header">
    <div class="accordion__header-title">
      <h2>{{ title | translate}}</h2>
      <svg class="accordion__header-title__icon" [ngClass]="{'rotate-icon': !isCollapsed}" (click)="isCollapsed = !isCollapsed; isAccordionOpened()">
        <use href="#icon-arrow-down-bold"></use>
      </svg>
    </div>
    <h3 class="accordion__header-subtitle">{{ subtitle | translate }}</h3>
  </div>
  <div *ngIf="!isCollapsed" class="accordion__content">
    <div class="accordion-separator"></div>
    <ng-content></ng-content>
  </div>
</div>
